import { manifests as configManifests } from './config/manifests.js';

export const manifests = [...configManifests];
